// Centralized translations file - ALL texts in one place
// Portuguese (pt) and English (en)

export const translations = {
  // ==================== COMMON / GLOBAL ====================
  common: {
    pt: {
      appName: 'MagicStay Homes',
      loading: 'Carregando...',
      save: 'Salvar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      edit: 'Editar',
      create: 'Criar',
      search: 'Buscar',
      filter: 'Filtrar',
      filters: 'Filtros',
      clear: 'Limpar',
      apply: 'Aplicar',
      confirm: 'Confirmar',
      back: 'Voltar',
      next: 'Próximo',
      previous: 'Anterior',
      submit: 'Enviar',
      close: 'Fechar',
      yes: 'Sim',
      no: 'Não',
      or: 'ou',
      and: 'e',
      any: 'Qualquer',
      all: 'Todos',
      none: 'Nenhum',
      optional: 'Opcional',
      required: 'Obrigatório',
      success: 'Sucesso',
      error: 'Erro',
      warning: 'Aviso',
      info: 'Informação',
      home: 'Início',
      homePage: 'Início',
      login: 'Entrar',
      logout: 'Sair',
      register: 'Cadastrar',
      email: 'Email',
      password: 'Senha',
      name: 'Nome',
      phone: 'Telefone',
      address: 'Endereço',
      city: 'Cidade',
      state: 'Estado',
      country: 'País',
      zipCode: 'CEP',
      description: 'Descrição',
      title: 'Título',
      price: 'Preço',
      date: 'Data',
      time: 'Hora',
      from: 'De',
      to: 'Até',
      min: 'Mín',
      max: 'Máx',
      total: 'Total',
      perNight: '/noite',
      nights: 'noites',
      night: 'noite',
      guests: 'hóspedes',
      guest: 'hóspede',
      bedrooms: 'quartos',
      bedroom: 'quarto',
      bathrooms: 'banheiros',
      bathroom: 'banheiro',
      area: 'Área',
      sqft: 'ft²',
      miles: 'milhas',
      photos: 'Fotos',
      video: 'Vídeo',
      map: 'Mapa',
      list: 'Lista',
      grid: 'Grade',
      viewMore: 'Ver mais',
      viewLess: 'Ver menos',
      viewAll: 'Ver todos',
      viewDetails: 'Ver detalhes',
      share: 'Compartilhar',
      favorite: 'Favoritar',
      compare: 'Comparar',
      contact: 'Contato',
      message: 'Mensagem',
      send: 'Enviar',
      refresh: 'Atualizar',
      retry: 'Tentar novamente',
      uploadImage: 'Carregar imagem',
      dragDropFiles: 'Arraste arquivos ou clique para enviar',
      selectFiles: 'Selecionar arquivos',
      verified: 'Verificado',
      sponsored: 'Patrocinado',
      featured: 'Destaque',
      new: 'Novo',
      popular: 'Popular',
      recommended: 'Recomendado',
      results: 'resultados',
      result: 'resultado',
      noResults: 'Nenhum resultado encontrado',
      tryAgain: 'Tente novamente',
      somethingWentWrong: 'Algo deu errado',
    },
    en: {
      appName: 'MagicStay Homes',
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      filters: 'Filters',
      clear: 'Clear',
      apply: 'Apply',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      or: 'or',
      and: 'and',
      any: 'Any',
      all: 'All',
      none: 'None',
      optional: 'Optional',
      required: 'Required',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Information',
      home: 'Home',
      homePage: 'Home',
      login: 'Login',
      logout: 'Logout',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      phone: 'Phone',
      address: 'Address',
      city: 'City',
      state: 'State',
      country: 'Country',
      zipCode: 'ZIP Code',
      description: 'Description',
      title: 'Title',
      price: 'Price',
      date: 'Date',
      time: 'Time',
      from: 'From',
      to: 'To',
      min: 'Min',
      max: 'Max',
      total: 'Total',
      perNight: '/night',
      nights: 'nights',
      night: 'night',
      guests: 'guests',
      guest: 'guest',
      bedrooms: 'bedrooms',
      bedroom: 'bedroom',
      bathrooms: 'bathrooms',
      bathroom: 'bathroom',
      area: 'Area',
      sqft: 'ft²',
      miles: 'miles',
      photos: 'Photos',
      video: 'Video',
      map: 'Map',
      list: 'List',
      grid: 'Grid',
      viewMore: 'View more',
      viewLess: 'View less',
      viewAll: 'View all',
      viewDetails: 'View details',
      share: 'Share',
      favorite: 'Favorite',
      compare: 'Compare',
      contact: 'Contact',
      message: 'Message',
      send: 'Send',
      refresh: 'Refresh',
      retry: 'Try again',
      uploadImage: 'Upload image',
      dragDropFiles: 'Drag files or click to upload',
      selectFiles: 'Select files',
      verified: 'Verified',
      sponsored: 'Sponsored',
      featured: 'Featured',
      new: 'New',
      popular: 'Popular',
      recommended: 'Recommended',
      results: 'results',
      result: 'result',
      noResults: 'No results found',
      tryAgain: 'Try again',
      somethingWentWrong: 'Something went wrong',
    }
  },

  // ==================== NAVBAR ====================
  navbar: {
    pt: {
      searchProperties: 'Buscar Imóveis',
      listProperty: 'Anuncie seu Imóvel',
      plans: 'Anuncie seu Imóvel',
      myListings: 'Meus Anúncios',
      myAccount: 'Minha Conta',
      favorites: 'Favoritos',
      savedSearches: 'Buscas Salvas',
      dashboard: 'Painel',
      adminPanel: 'Painel Admin',
      visitor: 'Visitante',
      login: 'Entrar',
      logout: 'Sair',
      register: 'Cadastrar',
    },
    en: {
      searchProperties: 'Search Properties',
      listProperty: 'List Your Property',
      plans: 'List Your Property',
      myListings: 'My Listings',
      myAccount: 'My Account',
      favorites: 'Favorites',
      savedSearches: 'Saved Searches',
      dashboard: 'Dashboard',
      adminPanel: 'Admin Panel',
      visitor: 'Visitor',
      login: 'Login',
      logout: 'Logout',
      register: 'Sign Up',
    }
  },

  // ==================== FOOTER ====================
  footer: {
    pt: {
      company: 'Empresa',
      about: 'Sobre',
      howItWorks: 'Como Funciona',
      plans: 'Anuncie seu Imóvel',
      support: 'Suporte',
      faq: 'Perguntas Frequentes',
      contact: 'Contato',
      terms: 'Termos de Uso',
      privacy: 'Privacidade',
      allRightsReserved: 'Todos os direitos reservados',
      followUs: 'Siga-nos',
    },
    en: {
      company: 'Company',
      about: 'About',
      howItWorks: 'How It Works',
      plans: 'List Your Property',
      support: 'Support',
      faq: 'FAQ',
      contact: 'Contact',
      terms: 'Terms of Service',
      privacy: 'Privacy Policy',
      allRightsReserved: 'All rights reserved',
      followUs: 'Follow us',
    }
  },

  // ==================== HOME PAGE ====================
  home: {
    pt: {
      heroTitle: 'Encontre a casa perfeita para suas férias em Orlando',
      heroSubtitle: 'Casas de temporada perto da Disney, sem taxas de reserva',
      searchPlaceholder: 'Orlando, Disney World, Lake Buena Vista...',
      nearMe: 'Perto de Mim',
      guestsLabel: 'hóspedes',
      anyPrice: 'Qualquer preço',
      // Welcome section
      welcome: 'Bem-vindo ao MagicStay Homes',
      welcomeTitle: 'Bem-vindo ao MagicStay Homes',
      welcomeSubtitle: 'A plataforma que conecta você às melhores casas de temporada em Orlando',
      // Search card
      searchProperties: 'Buscar Imóveis',
      searchPropertiesTitle: 'Buscar Imóveis',
      searchDescription: 'Encontre casas incríveis perto da Disney',
      searchPropertiesDesc: 'Encontre casas incríveis perto da Disney',
      startSearching: 'Começar a Buscar',
      // List card  
      listProperty: 'Anunciar Imóvel',
      listPropertyTitle: 'Anunciar Imóvel',
      listDescription: 'Anuncie sua casa sem pagar comissão por reserva',
      listPropertyDesc: 'Anuncie sua casa sem pagar comissão por reserva',
      startListing: 'Começar a Anunciar',
      // Features section
      whyMagicstay: 'Por que escolher o MagicStay?',
      whyChooseUs: 'Por que escolher o MagicStay?',
      uniqueExperience: 'Oferecemos uma experiência única para você e sua família',
      verifiedProperties: 'Imóveis Verificados',
      verifiedDescription: 'Todos os imóveis passam por verificação de documentos.',
      verifiedPropertiesDesc: 'Todos os imóveis passam por verificação de documentos.',
      noFees: 'Sem Taxas de Reserva',
      noFeesDescription: 'Zero taxas por reserva. Apenas uma mensalidade fixa.',
      noCommissions: 'Sem Comissões',
      noCommissionsDesc: 'Zero taxas por reserva. Apenas uma mensalidade fixa.',
      superHosts: 'Super Anfitriões',
      superHostsDescription: 'Anfitriões experientes e bem avaliados.',
      privatePools: 'Piscinas Privativas',
      privatePoolsDescription: 'A maioria das casas possui piscina privativa.',
      directContact: 'Contato Direto',
      directContactDesc: 'Fale diretamente com os anfitriões via WhatsApp ou email.',
      // CTA section
      ctaTitle: 'Pronto para encontrar sua casa dos sonhos?',
      ctaSubtitle: 'Junte-se a milhares de famílias que já encontraram o lugar perfeito em Orlando',
      ctaButton: 'Explorar Imóveis',
      // Featured section
      featuredProperties: 'Imóveis em Destaque',
      featuredSubtitle: 'Casas selecionadas especialmente para você',
      viewAllProperties: 'Ver Todos os Imóveis',
      loginToList: 'Faça login para anunciar seu imóvel',
      errorLoading: 'Erro ao carregar imóveis',
      searchButton: 'Buscar',
      // Diamond section
      diamondProperties: 'Imóveis Diamond',
      diamondDescription: 'Imóveis premium com selo de qualidade Diamond',
      exclusiveDiamond: 'Diamond Exclusivo',
      luxuryProperty: 'imóvel de luxo',
      luxuryProperties: 'imóveis de luxo',
      premiumSelection: 'Seleção Premium',
      moreExclusive: 'Mais exclusivos',
      perNight: '/noite',
      // Featured section extended
      featuredDescription: 'Casas selecionadas especialmente para você',
      viewAll: 'Ver Todos',
      noPropertiesTitle: 'Nenhum imóvel disponível',
      noPropertiesSubtitle: 'Ainda não temos imóveis cadastrados. Seja o primeiro a anunciar!',
      seeAllProperties: 'Ver Todos os Imóveis',
    },
    en: {
      heroTitle: 'Find the perfect vacation home in Orlando',
      heroSubtitle: 'Vacation rentals near Disney, no booking fees',
      searchPlaceholder: 'Orlando, Disney World, Lake Buena Vista...',
      nearMe: 'Near Me',
      guestsLabel: 'guests',
      anyPrice: 'Any price',
      // Welcome section
      welcome: 'Welcome to MagicStay Homes',
      welcomeTitle: 'Welcome to MagicStay Homes',
      welcomeSubtitle: 'The platform that connects you to the best vacation homes in Orlando',
      // Search card
      searchProperties: 'Search Properties',
      searchPropertiesTitle: 'Search Properties',
      searchDescription: 'Find amazing homes near Disney',
      searchPropertiesDesc: 'Find amazing homes near Disney',
      startSearching: 'Start Searching',
      // List card
      listProperty: 'List Property',
      listPropertyTitle: 'List Property',
      listDescription: 'List your home without paying booking commissions',
      listPropertyDesc: 'List your home without paying booking commissions',
      startListing: 'Start Listing',
      // Features section
      whyMagicstay: 'Why choose MagicStay?',
      whyChooseUs: 'Why choose MagicStay?',
      uniqueExperience: 'We offer a unique experience for you and your family',
      verifiedProperties: 'Verified Properties',
      verifiedDescription: 'All properties undergo document verification.',
      verifiedPropertiesDesc: 'All properties undergo document verification.',
      noFees: 'No Booking Fees',
      noFeesDescription: 'Zero booking fees. Just a fixed monthly fee.',
      noCommissions: 'No Commissions',
      noCommissionsDesc: 'Zero booking fees. Just a fixed monthly fee.',
      superHosts: 'Super Hosts',
      superHostsDescription: 'Experienced and well-rated hosts.',
      privatePools: 'Private Pools',
      privatePoolsDescription: 'Most homes have private pools.',
      directContact: 'Direct Contact',
      directContactDesc: 'Talk directly with hosts via WhatsApp or email.',
      // CTA section
      ctaTitle: 'Ready to find your dream home?',
      ctaSubtitle: 'Join thousands of families who have already found the perfect place in Orlando',
      ctaButton: 'Explore Properties',
      // Featured section
      featuredProperties: 'Featured Properties',
      featuredSubtitle: 'Homes specially selected for you',
      viewAllProperties: 'View All Properties',
      loginToList: 'Login to list your property',
      errorLoading: 'Error loading properties',
      searchButton: 'Search',
      // Diamond section
      diamondProperties: 'Diamond Properties',
      diamondDescription: 'Premium properties with Diamond quality seal',
      exclusiveDiamond: 'Exclusive Diamond',
      luxuryProperty: 'luxury property',
      luxuryProperties: 'luxury properties',
      premiumSelection: 'Premium Selection',
      moreExclusive: 'More exclusive',
      perNight: '/night',
      // Featured section extended
      featuredDescription: 'Homes specially selected for you',
      viewAll: 'View All',
      noPropertiesTitle: 'No properties available',
      noPropertiesSubtitle: 'No properties registered yet. Be the first to list!',
      seeAllProperties: 'See All Properties',
    }
  },

  // ==================== SEARCH / FILTER ====================
  search: {
    pt: {
      title: 'Buscar Imóveis',
      findYourIdealProperty: 'Encontre seu imóvel ideal',
      pricePerNight: 'Preço por Noite',
      numberOfGuests: 'Número de Hóspedes',
      propertyType: 'Tipo de Imóvel',
      specificType: 'Tipo Específico',
      areaSize: 'Área (ft²)',
      bedroomsCount: 'Quartos',
      bathroomsCount: 'Banheiros',
      minRating: 'Avaliação Mínima',
      cancellationPolicy: 'Política de Cancelamento',
      houseRules: 'Regras da Casa',
      amenities: 'Comodidades',
      distanceToDisney: 'Distância da Disney',
      hostLanguages: 'Idiomas do Anfitrião',
      verifiedOnly: 'Apenas Verificados',
      clearFilters: 'Limpar Filtros',
      applyFilters: 'Aplicar Filtros',
      activeFilters: 'filtro(s) ativo(s)',
      propertiesFound: 'imóveis encontrados',
      sortBy: 'Ordenar por',
      relevance: 'Relevância',
      priceLowHigh: 'Preço: menor para maior',
      priceHighLow: 'Preço: maior para menor',
      newest: 'Mais recentes',
      rating: 'Avaliação',
      searchByFilters: 'Buscar por Filtros',
      searchByPhoto: 'Buscar por Foto',
      diamondProperties: 'Imóveis Diamond',
      compareMode: 'Modo Comparação',
      exitMode: 'Sair do Modo',
      showMap: 'Mostrar Mapa',
      hideMap: 'Ocultar Mapa',
      previousPage: 'Voltar',
      loadMore: 'Carregar Mais',
      saveSearch: 'Salvar Busca',
      myFavorites: 'Meus Favoritos',
      howManyGuests: 'Quantos?',
      whichType: 'Qual?',
      // Property types
      house: 'Casa',
      apartment: 'Apartamento',
      condo: 'Condomínio',
      villa: 'Villa',
      townhouse: 'Sobrado',
      beachHouse: 'Casa de Praia',
      chalet: 'Chalé',
      luxuryApartment: 'Apartamento Luxo',
      penthouse: 'Cobertura',
      cottage: 'Cottage',
      // Cancellation policies
      flexible: 'Flexível',
      moderate: 'Moderada',
      strict: 'Rigorosa',
      // Amenities
      pool: 'Piscina',
      wifi: 'Wi-Fi',
      parking: 'Estacionamento',
      airConditioning: 'Ar Condicionado',
      kitchen: 'Cozinha',
      washer: 'Máquina de Lavar',
      dryer: 'Secadora',
      tv: 'TV',
      gym: 'Academia',
      hotTub: 'Jacuzzi',
      bbqGrill: 'Churrasqueira',
      gameRoom: 'Sala de Jogos',
      petFriendly: 'Aceita Pets',
      wheelchairAccessible: 'Acessível',
      // Rules
      allowsParties: 'Permite Festas',
      allowsSmoking: 'Permite Fumar',
      allowsChildren: 'Permite Crianças',
      // Languages
      portuguese: 'Português',
      english: 'Inglês',
      spanish: 'Espanhol',
      french: 'Francês',
      // Toasts
      loginToSaveSearches: 'Faça login para salvar buscas',
      searchSaved: 'Busca salva com sucesso!',
      manageSavedSearches: 'Você pode gerenciar suas buscas salvas na página Buscas Salvas',
      errorLoadingProperties: 'Erro ao carregar imóveis',
      errorLoadingMore: 'Erro ao carregar mais imóveis',
      newPropertiesLoaded: 'novos imóveis carregados',
      noSimilarFound: 'Nenhum imóvel similar encontrado',
      similarFound: 'imóvel(is) similar(es) encontrado(s)',
      selectImageFirst: 'Selecione uma imagem primeiro',
      errorSearchingImage: 'Erro ao buscar por imagem. Tente novamente.',
      selectValidImage: 'Por favor, selecione um arquivo de imagem válido',
      imagePasted: 'Imagem colada com sucesso!',
    },
    en: {
      title: 'Search Properties',
      findYourIdealProperty: 'Find your ideal property',
      pricePerNight: 'Price per Night',
      numberOfGuests: 'Number of Guests',
      propertyType: 'Property Type',
      specificType: 'Specific Type',
      areaSize: 'Area (ft²)',
      bedroomsCount: 'Bedrooms',
      bathroomsCount: 'Bathrooms',
      minRating: 'Minimum Rating',
      cancellationPolicy: 'Cancellation Policy',
      houseRules: 'House Rules',
      amenities: 'Amenities',
      distanceToDisney: 'Distance to Disney',
      hostLanguages: 'Host Languages',
      verifiedOnly: 'Verified Only',
      clearFilters: 'Clear Filters',
      applyFilters: 'Apply Filters',
      activeFilters: 'active filter(s)',
      propertiesFound: 'properties found',
      sortBy: 'Sort by',
      relevance: 'Relevance',
      priceLowHigh: 'Price: low to high',
      priceHighLow: 'Price: high to low',
      newest: 'Newest',
      rating: 'Rating',
      searchByFilters: 'Search by Filters',
      searchByPhoto: 'Search by Photo',
      diamondProperties: 'Diamond Properties',
      compareMode: 'Compare Mode',
      exitMode: 'Exit Mode',
      showMap: 'Show Map',
      hideMap: 'Hide Map',
      previousPage: 'Back',
      loadMore: 'Load More',
      saveSearch: 'Save Search',
      myFavorites: 'My Favorites',
      howManyGuests: 'How many?',
      whichType: 'Which?',
      // Property types
      house: 'House',
      apartment: 'Apartment',
      condo: 'Condo',
      villa: 'Villa',
      townhouse: 'Townhouse',
      beachHouse: 'Beach House',
      chalet: 'Chalet',
      luxuryApartment: 'Luxury Apartment',
      penthouse: 'Penthouse',
      cottage: 'Cottage',
      // Cancellation policies
      flexible: 'Flexible',
      moderate: 'Moderate',
      strict: 'Strict',
      // Amenities
      pool: 'Pool',
      wifi: 'Wi-Fi',
      parking: 'Parking',
      airConditioning: 'Air Conditioning',
      kitchen: 'Kitchen',
      washer: 'Washer',
      dryer: 'Dryer',
      tv: 'TV',
      gym: 'Gym',
      hotTub: 'Hot Tub',
      bbqGrill: 'BBQ Grill',
      gameRoom: 'Game Room',
      petFriendly: 'Pet Friendly',
      wheelchairAccessible: 'Wheelchair Accessible',
      // Rules
      allowsParties: 'Allows Parties',
      allowsSmoking: 'Allows Smoking',
      allowsChildren: 'Allows Children',
      // Languages
      portuguese: 'Portuguese',
      english: 'English',
      spanish: 'Spanish',
      french: 'French',
      // Toasts
      loginToSaveSearches: 'Login to save searches',
      searchSaved: 'Search saved successfully!',
      manageSavedSearches: 'You can manage your saved searches on the Saved Searches page',
      errorLoadingProperties: 'Error loading properties',
      errorLoadingMore: 'Error loading more properties',
      newPropertiesLoaded: 'new properties loaded',
      noSimilarFound: 'No similar properties found',
      similarFound: 'similar property(ies) found',
      selectImageFirst: 'Select an image first',
      errorSearchingImage: 'Error searching by image. Try again.',
      selectValidImage: 'Please select a valid image file',
      imagePasted: 'Image pasted successfully!',
    }
  },

  // ==================== PROPERTY DETAILS ====================
  property: {
    pt: {
      aboutProperty: 'Sobre este imóvel',
      amenities: 'Comodidades',
      location: 'Localização',
      houseRules: 'Regras da Casa',
      reviews: 'Avaliações',
      hostInfo: 'Sobre o Anfitrião',
      contactHost: 'Contatar Anfitrião',
      sendMessage: 'Enviar Mensagem',
      callNow: 'Ligar Agora',
      whatsapp: 'WhatsApp',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      minNights: 'Mínimo de noites',
      cleaningFee: 'Taxa de limpeza',
      securityDeposit: 'Depósito de segurança',
      superHost: 'Super Anfitrião',
      memberSince: 'Membro desde',
      responseTime: 'Tempo de resposta',
      responseRate: 'Taxa de resposta',
      writeReview: 'Escrever Avaliação',
      noReviews: 'Ainda não há avaliações',
      beFirstToReview: 'Seja o primeiro a avaliar este imóvel',
      showAllAmenities: 'Mostrar todas as comodidades',
      showAllReviews: 'Mostrar todas as avaliações',
      reportListing: 'Reportar anúncio',
      shareListing: 'Compartilhar anúncio',
      saveListing: 'Salvar anúncio',
      similarProperties: 'Imóveis similares',
      distanceFromDisney: 'Distância da Disney',
      distanceFromUniversal: 'Distância da Universal',
      viewOnMap: 'Ver no mapa',
      propertyNotFound: 'Imóvel não encontrado',
      loginToContact: 'Faça login para entrar em contato',
      contactSent: 'Mensagem enviada com sucesso!',
      errorSendingContact: 'Erro ao enviar mensagem',
    },
    en: {
      aboutProperty: 'About this property',
      amenities: 'Amenities',
      location: 'Location',
      houseRules: 'House Rules',
      reviews: 'Reviews',
      hostInfo: 'About the Host',
      contactHost: 'Contact Host',
      sendMessage: 'Send Message',
      callNow: 'Call Now',
      whatsapp: 'WhatsApp',
      checkIn: 'Check-in',
      checkOut: 'Check-out',
      minNights: 'Minimum nights',
      cleaningFee: 'Cleaning fee',
      securityDeposit: 'Security deposit',
      superHost: 'Super Host',
      memberSince: 'Member since',
      responseTime: 'Response time',
      responseRate: 'Response rate',
      writeReview: 'Write Review',
      noReviews: 'No reviews yet',
      beFirstToReview: 'Be the first to review this property',
      showAllAmenities: 'Show all amenities',
      showAllReviews: 'Show all reviews',
      reportListing: 'Report listing',
      shareListing: 'Share listing',
      saveListing: 'Save listing',
      similarProperties: 'Similar properties',
      distanceFromDisney: 'Distance from Disney',
      distanceFromUniversal: 'Distance from Universal',
      viewOnMap: 'View on map',
      propertyNotFound: 'Property not found',
      loginToContact: 'Login to contact host',
      contactSent: 'Message sent successfully!',
      errorSendingContact: 'Error sending message',
    }
  },

  // ==================== AUTH (Login/Register) ====================
  auth: {
    pt: {
      welcomeBack: 'Bem-vindo de volta',
      enterCredentials: 'Digite suas credenciais para continuar',
      emailPlaceholder: 'seu@email.com',
      passwordPlaceholder: 'Sua senha',
      forgotPassword: 'Esqueceu a senha?',
      loginButton: 'Entrar',
      loggingIn: 'Entrando...',
      noAccount: 'Não tem uma conta?',
      signUp: 'Cadastre-se',
      createAccount: 'Criar Conta',
      createAccountDesc: 'Preencha os dados para se cadastrar',
      fullName: 'Nome Completo',
      namePlaceholder: 'Seu nome completo',
      confirmPassword: 'Confirmar Senha',
      confirmPasswordPlaceholder: 'Confirme sua senha',
      iAmHost: 'Quero anunciar imóveis (sou anfitrião)',
      creating: 'Criando...',
      alreadyHaveAccount: 'Já tem uma conta?',
      signIn: 'Entre',
      recoverPassword: 'Recuperar Senha',
      recoverPasswordDesc: 'Digite seu email para receber o link de recuperação',
      sendRecoveryLink: 'Enviar Link de Recuperação',
      sending: 'Enviando...',
      backToLogin: 'Voltar ao Login',
      checkEmail: 'Verifique seu email para redefinir sua senha',
      emailSentTo: 'Enviamos um link de recuperação para',
      checkInbox: 'Verifique sua caixa de entrada e spam.',
      linkExpires: 'O link expira em 1 hora.',
      didntReceive: 'Não recebeu o email?',
      resendEmail: 'Reenviar Email',
      resetPassword: 'Redefinir Senha',
      resetPasswordDesc: 'Digite sua nova senha abaixo',
      newPassword: 'Nova Senha',
      newPasswordPlaceholder: 'Digite sua nova senha',
      confirmNewPassword: 'Confirmar Nova Senha',
      resetting: 'Redefinindo...',
      passwordReset: 'Senha Redefinida!',
      passwordResetSuccess: 'Sua senha foi alterada com sucesso. Você será redirecionado para a página de login...',
      minChars: 'Mínimo de 6 caracteres',
      passwordsDontMatch: 'As senhas não coincidem',
      invalidCredentials: 'Email ou senha inválidos',
      emailAlreadyExists: 'Este email já está cadastrado',
      registrationSuccess: 'Cadastro realizado com sucesso!',
      loginSuccess: 'Login realizado com sucesso!',
      logoutSuccess: 'Você saiu da sua conta',
    },
    en: {
      welcomeBack: 'Welcome back',
      enterCredentials: 'Enter your credentials to continue',
      emailPlaceholder: 'your@email.com',
      passwordPlaceholder: 'Your password',
      forgotPassword: 'Forgot password?',
      loginButton: 'Login',
      loggingIn: 'Logging in...',
      noAccount: "Don't have an account?",
      signUp: 'Sign up',
      createAccount: 'Create Account',
      createAccountDesc: 'Fill in the details to register',
      fullName: 'Full Name',
      namePlaceholder: 'Your full name',
      confirmPassword: 'Confirm Password',
      confirmPasswordPlaceholder: 'Confirm your password',
      iAmHost: 'I want to list properties (I am a host)',
      creating: 'Creating...',
      alreadyHaveAccount: 'Already have an account?',
      signIn: 'Sign in',
      recoverPassword: 'Recover Password',
      recoverPasswordDesc: 'Enter your email to receive the recovery link',
      sendRecoveryLink: 'Send Recovery Link',
      sending: 'Sending...',
      backToLogin: 'Back to Login',
      checkEmail: 'Check your email to reset your password',
      emailSentTo: 'We sent a recovery link to',
      checkInbox: 'Check your inbox and spam folder.',
      linkExpires: 'The link expires in 1 hour.',
      didntReceive: "Didn't receive the email?",
      resendEmail: 'Resend Email',
      resetPassword: 'Reset Password',
      resetPasswordDesc: 'Enter your new password below',
      newPassword: 'New Password',
      newPasswordPlaceholder: 'Enter your new password',
      confirmNewPassword: 'Confirm New Password',
      resetting: 'Resetting...',
      passwordReset: 'Password Reset!',
      passwordResetSuccess: 'Your password has been changed successfully. You will be redirected to the login page...',
      minChars: 'Minimum 6 characters',
      passwordsDontMatch: 'Passwords do not match',
      invalidCredentials: 'Invalid email or password',
      emailAlreadyExists: 'This email is already registered',
      registrationSuccess: 'Registration successful!',
      loginSuccess: 'Login successful!',
      logoutSuccess: 'You have been logged out',
    }
  },

  // ==================== HOST DASHBOARD ====================
  host: {
    pt: {
      dashboard: 'Painel do Anfitrião',
      dashboardDesc: 'Gerencie seus imóveis e acompanhe suas estatísticas',
      createNewListing: 'Criar Novo Anúncio',
      createListing: 'Criar Anúncio',
      totalProperties: 'Total de Imóveis',
      activeProperties: 'Imóveis Ativos',
      contacts: 'Contatos',
      views: 'Visualizações',
      myProperties: 'Meus Imóveis',
      noProperties: 'Nenhum imóvel cadastrado',
      noPropertiesDesc: 'Comece anunciando seu primeiro imóvel no MagicStay Homes',
      createFirstListing: 'Criar Primeiro Anúncio',
      activate: 'Ativar',
      deactivate: 'Desativar',
      viewListing: 'Ver Anúncio',
      remove: 'Remover',
      resendDocs: 'Reenviar Documentos',
      noContacts: 'Nenhum contato recebido',
      noContactsDesc: 'Quando hóspedes entrarem em contato, eles aparecerão aqui',
      confirmDelete: 'Confirmar exclusão',
      confirmDeleteDesc: 'Tem certeza que deseja excluir a propriedade',
      cannotBeUndone: 'Esta ação não pode ser desfeita.',
      verificationPending: 'Verificação Pendente',
      verificationRejected: 'Verificação Rejeitada',
      statusActive: 'Ativo',
      statusPending: 'Pendente',
      statusInactive: 'Inativo',
      statusPaused: 'Pausado',
      activated: 'ativado',
      deactivated: 'desativado',
      listingSuccess: 'Anúncio {status} com sucesso',
      errorToggle: 'Erro ao {action} anúncio',
      deleteSuccess: 'Propriedade excluída com sucesso',
      deleteError: 'Erro ao excluir propriedade',
      backToDashboard: 'Voltar ao Painel',
    },
    en: {
      dashboard: 'Host Dashboard',
      dashboardDesc: 'Manage your properties and track your statistics',
      createNewListing: 'Create New Listing',
      createListing: 'Create Listing',
      totalProperties: 'Total Properties',
      activeProperties: 'Active Properties',
      contacts: 'Contacts',
      views: 'Views',
      myProperties: 'My Properties',
      noProperties: 'No properties registered',
      noPropertiesDesc: 'Start listing your first property on MagicStay Homes',
      createFirstListing: 'Create First Listing',
      activate: 'Activate',
      deactivate: 'Deactivate',
      viewListing: 'View Listing',
      remove: 'Remove',
      resendDocs: 'Resend Documents',
      noContacts: 'No contacts received',
      noContactsDesc: 'When guests contact you, they will appear here',
      confirmDelete: 'Confirm deletion',
      confirmDeleteDesc: 'Are you sure you want to delete the property',
      cannotBeUndone: 'This action cannot be undone.',
      verificationPending: 'Verification Pending',
      verificationRejected: 'Verification Rejected',
      statusActive: 'Active',
      statusPending: 'Pending',
      statusInactive: 'Inactive',
      statusPaused: 'Paused',
      activated: 'activated',
      deactivated: 'deactivated',
      listingSuccess: 'Listing {status} successfully',
      errorToggle: 'Error {action} listing',
      deleteSuccess: 'Property deleted successfully',
      deleteError: 'Error deleting property',
      backToDashboard: 'Back to Dashboard',
    }
  },

  // ==================== CREATE/EDIT PROPERTY ====================
  createProperty: {
    pt: {
      title: 'Criar Novo Anúncio',
      editTitle: 'Editar Imóvel',
      subtitle: 'Preencha as informações do seu imóvel',
      step: 'Passo',
      basicInfo: 'Informações Básicas',
      describeProperty: 'Descreva seu imóvel',
      listingTitle: 'Título do Anúncio',
      titlePlaceholder: 'Ex: Casa espaçosa perto da Disney',
      descriptionPlaceholder: 'Descreva os destaques do seu imóvel...',
      locationDetails: 'Localização e Detalhes',
      whereIsProperty: 'Onde fica seu imóvel?',
      condoName: 'Nome do Condomínio',
      distanceDisney: 'Distância da Disney (milhas)',
      distanceUniversal: 'Distância da Universal (milhas)',
      amenitiesTitle: 'Comodidades',
      amenitiesDesc: 'Quais comodidades seu imóvel oferece?',
      rulesAndPricing: 'Regras e Preços',
      defineRules: 'Defina as regras e preços',
      checkInTime: 'Horário Check-in',
      checkOutTime: 'Horário Check-out',
      minimumNights: 'Mínimo de Noites',
      nightlyPrice: 'Preço por Noite ($)',
      cleaningFee: 'Taxa de Limpeza ($)',
      securityDeposit: 'Depósito ($)',
      planAndPhotos: 'Plano e Fotos',
      choosePlanAndPhotos: 'Escolha seu plano e adicione fotos',
      subscriptionPlan: 'Plano de Assinatura',
      uploadPhotos: 'Upload de Fotos',
      addImageUrl: 'Adicionar URL',
      videoUrl: 'URL do Vídeo (YouTube ou Vimeo)',
      contactInfo: 'Informações de Contato',
      contactEmail: 'Email de Contato',
      verification: 'Verificação de Propriedade (Opcional)',
      verificationDesc: 'Envie documentos para verificar seu imóvel',
      skipVerification: 'Pular verificação (enviar depois)',
      documentType: 'Tipo de Documento',
      propertyContract: 'Contrato de Propriedade',
      deed: 'Escritura',
      utilityBill: 'Conta de Luz/Água',
      thirdPartyContract: 'Contrato de terceiro + Procuração',
      uploadDocs: 'Upload de Documentos (máx. 5 arquivos)',
      docRequired: 'Pelo menos 1 documento é obrigatório para verificação',
      creating: 'Criando...',
      saving: 'Salvando...',
      createButton: 'Criar Anúncio',
      saveButton: 'Salvar Alterações',
      success: 'Imóvel criado com sucesso!',
      successWithDocs: 'Imóvel criado e documentos de verificação enviados! Aguardando análise.',
      errorDocs: 'Imóvel criado, mas houve erro ao enviar documentos. Você pode reenviar depois.',
      updateSuccess: 'Imóvel atualizado com sucesso!',
      error: 'Erro ao criar imóvel',
      updateError: 'Erro ao atualizar imóvel',
      freeAccess: 'Você tem Acesso Gratuito!',
      freeAccessPlans: 'Plano(s) disponível(is) sem custo:',
      thisPlanIsFree: 'Este plano está gratuito para você!',
      coordinatesTitle: 'Coordenadas Exatas do Imóvel (Recomendado)',
      coordinatesDesc: 'Para garantir a localização precisa no mapa, copie e cole as coordenadas do Google Maps',
      howToGetCoords: 'Como obter as coordenadas:',
      openGoogleMaps: 'Abra o Google Maps no navegador',
      enterAddress: 'Digite o endereço completo do seu imóvel',
      rightClick: 'Clique com o botão direito no marcador vermelho',
      clickFirstLine: 'Clique na primeira linha com os números (ex: 28.3185, -81.4187)',
      pasteCoordinates: 'Cole as Coordenadas',
      coordsDetected: 'Coordenadas detectadas:',
      coordsTip: 'Dica: Se não informar, usaremos as coordenadas aproximadas baseadas no CEP',
      mapLocation: 'Localização no Mapa',
      viewExactLocation: 'Visualize a localização exata do imóvel',
      viewOnMap: 'Ver no Mapa',
      propertyLocation: 'Localização do Imóvel',
      fillAddressForMap: 'Preencha o endereço completo para visualizar no mapa',
      imagesCompressed: 'imagens comprimidas com sucesso',
      addressAutoFilled: 'Endereço e coordenadas preenchidos automaticamente!',
      code: 'Código',
      number: 'Número',
    },
    en: {
      title: 'Create New Listing',
      editTitle: 'Edit Property',
      subtitle: 'Fill in your property information',
      step: 'Step',
      basicInfo: 'Basic Information',
      describeProperty: 'Describe your property',
      listingTitle: 'Listing Title',
      titlePlaceholder: 'Ex: Spacious house near Disney',
      descriptionPlaceholder: 'Describe the highlights of your property...',
      locationDetails: 'Location and Details',
      whereIsProperty: 'Where is your property?',
      condoName: 'Condo Name',
      distanceDisney: 'Distance to Disney (miles)',
      distanceUniversal: 'Distance to Universal (miles)',
      amenitiesTitle: 'Amenities',
      amenitiesDesc: 'What amenities does your property offer?',
      rulesAndPricing: 'Rules and Pricing',
      defineRules: 'Define rules and prices',
      checkInTime: 'Check-in Time',
      checkOutTime: 'Check-out Time',
      minimumNights: 'Minimum Nights',
      nightlyPrice: 'Nightly Price ($)',
      cleaningFee: 'Cleaning Fee ($)',
      securityDeposit: 'Deposit ($)',
      planAndPhotos: 'Plan and Photos',
      choosePlanAndPhotos: 'Choose your plan and add photos',
      subscriptionPlan: 'Subscription Plan',
      uploadPhotos: 'Upload Photos',
      addImageUrl: 'Add URL',
      videoUrl: 'Video URL (YouTube or Vimeo)',
      contactInfo: 'Contact Information',
      contactEmail: 'Contact Email',
      verification: 'Property Verification (Optional)',
      verificationDesc: 'Submit documents to verify your property',
      skipVerification: 'Skip verification (submit later)',
      documentType: 'Document Type',
      propertyContract: 'Property Contract',
      deed: 'Deed',
      utilityBill: 'Utility Bill',
      thirdPartyContract: 'Third party contract + Power of Attorney',
      uploadDocs: 'Document Upload (max. 5 files)',
      docRequired: 'At least 1 document is required for verification',
      creating: 'Creating...',
      saving: 'Saving...',
      createButton: 'Create Listing',
      saveButton: 'Save Changes',
      success: 'Property created successfully!',
      successWithDocs: 'Property created and verification documents submitted! Awaiting review.',
      errorDocs: 'Property created, but error submitting documents. You can resend later.',
      updateSuccess: 'Property updated successfully!',
      error: 'Error creating property',
      updateError: 'Error updating property',
      freeAccess: 'You have Free Access!',
      freeAccessPlans: 'Plan(s) available for free:',
      thisPlanIsFree: 'This plan is free for you!',
      coordinatesTitle: 'Exact Property Coordinates (Recommended)',
      coordinatesDesc: 'To ensure accurate map location, copy and paste coordinates from Google Maps',
      howToGetCoords: 'How to get coordinates:',
      openGoogleMaps: 'Open Google Maps in browser',
      enterAddress: 'Enter the complete address of your property',
      rightClick: 'Right-click on the red marker',
      clickFirstLine: 'Click on the first line with numbers (e.g.: 28.3185, -81.4187)',
      pasteCoordinates: 'Paste Coordinates',
      coordsDetected: 'Coordinates detected:',
      coordsTip: 'Tip: If not provided, we will use approximate coordinates based on ZIP code',
      mapLocation: 'Map Location',
      viewExactLocation: 'View the exact location of the property',
      viewOnMap: 'View on Map',
      propertyLocation: 'Property Location',
      fillAddressForMap: 'Fill in the complete address to view on map',
      imagesCompressed: 'images compressed successfully',
      addressAutoFilled: 'Address and coordinates filled automatically!',
      code: 'Code',
      number: 'Number',
    }
  },

  // ==================== PLANS ====================
  plans: {
    pt: {
      title: 'Escolha Seu Plano',
      subtitle: 'Sem comissões por reserva. Apenas uma mensalidade fixa por anúncio.',
      freeTrial: '30 dias grátis no seu primeiro anúncio!',
      mostPopular: 'Mais Popular',
      perMonth: '/mês',
      perListing: 'por anúncio',
      upToPhotos: 'Até {count} fotos',
      videoAllowed: 'Vídeo permitido',
      noVideo: 'Sem vídeo',
      emailVisible: 'Email visível',
      whatsappButton: 'Botão WhatsApp',
      noWhatsapp: 'Sem WhatsApp',
      sponsoredListing: 'Anúncio Patrocinado',
      noBookingFees: 'Sem taxas de reserva',
      directContact: 'Contato direto com hóspedes',
      listingInResults: 'Anúncio nos resultados',
      socialLinks: 'Links para redes sociais',
      select: 'Selecionar',
      freeDays: '30 dias grátis no primeiro anúncio',
      faqTitle: 'Perguntas Frequentes sobre Planos',
      faqFreeTitle: 'Como funciona o período gratuito?',
      faqFreeDesc: 'Seu primeiro anúncio tem 30 dias gratuitos em qualquer plano. Após esse período, você será cobrado mensalmente.',
      faqCancelTitle: 'Posso cancelar a qualquer momento?',
      faqCancelDesc: 'Sim! Você pode pausar ou cancelar sua assinatura a qualquer momento sem multas.',
      faqChangeTitle: 'Posso mudar de plano depois?',
      faqChangeDesc: 'Sim, você pode fazer upgrade ou downgrade do seu plano a qualquer momento.',
    },
    en: {
      title: 'Choose Your Plan',
      subtitle: 'No booking commissions. Just a fixed monthly fee per listing.',
      freeTrial: '30 free days on your first listing!',
      mostPopular: 'Most Popular',
      perMonth: '/month',
      perListing: 'per listing',
      upToPhotos: 'Up to {count} photos',
      videoAllowed: 'Video allowed',
      noVideo: 'No video',
      emailVisible: 'Email visible',
      whatsappButton: 'WhatsApp button',
      noWhatsapp: 'No WhatsApp',
      sponsoredListing: 'Sponsored Listing',
      noBookingFees: 'No booking fees',
      directContact: 'Direct contact with guests',
      listingInResults: 'Listing in results',
      socialLinks: 'Social media links',
      select: 'Select',
      freeDays: '30 free days on first listing',
      faqTitle: 'Frequently Asked Questions about Plans',
      faqFreeTitle: 'How does the free period work?',
      faqFreeDesc: 'Your first listing has 30 free days on any plan. After that period, you will be charged monthly.',
      faqCancelTitle: 'Can I cancel at any time?',
      faqCancelDesc: 'Yes! You can pause or cancel your subscription at any time without penalties.',
      faqChangeTitle: 'Can I change my plan later?',
      faqChangeDesc: 'Yes, you can upgrade or downgrade your plan at any time.',
    }
  },

  // ==================== PAGES (FAQ, About, Contact, Terms, Privacy) ====================
  pages: {
    pt: {
      faqTitle: 'Perguntas Frequentes',
      aboutTitle: 'Sobre o MagicStay Homes',
      contactTitle: 'Entre em Contato',
      contactSubtitle: 'Tem dúvidas? Estamos aqui para ajudar!',
      sendYourMessage: 'Envie sua Mensagem',
      yourName: 'Seu nome completo',
      subject: 'Assunto',
      subjectPlaceholder: 'Sobre o que você quer falar?',
      messagePlaceholder: 'Escreva sua mensagem aqui...',
      sendMessage: 'Enviar Mensagem',
      messageSent: 'Mensagem enviada com sucesso! Responderemos em breve.',
      messageError: 'Erro ao enviar mensagem. Tente novamente.',
      termsTitle: 'Termos de Uso',
      privacyTitle: 'Política de Privacidade',
      lastUpdate: 'Última atualização: Dezembro 2024',
      howItWorksTitle: 'Como Funciona',
      howItWorksSubtitle: 'MagicStay Homes conecta proprietários e hóspedes de forma simples e transparente',
      forGuests: 'Para Hóspedes',
      forHosts: 'Para Anfitriões',
      ourDifference: 'Nossa Diferença',
      traditionalPlatforms: 'Plataformas Tradicionais',
      readyToStart: 'Pronto para Começar?',
      readySubtitle: 'Junte-se a centenas de anfitriões que já economizam em comissões',
      startNow: 'Começar Agora',
      viewFaq: 'Ver FAQ',
      notFoundAnswer: 'Não encontrou sua resposta?',
      teamReady: 'Nossa equipe está pronta para ajudar!',
      ourNumbers: 'Nossos Números',
      properties: 'Imóveis',
      guestsConnected: 'Hóspedes Conectados',
      averageRating: 'Avaliação Média',
      transparency: 'Transparência Total',
      transparencyDesc: 'Sem taxas escondidas. Sem comissões por reserva. Apenas uma mensalidade clara.',
      directContactTitle: 'Contato Direto',
      directContactDesc: 'Hóspedes e anfitriões conversam diretamente, sem intermediários.',
      fairGrowth: 'Crescimento Justo',
      fairGrowthDesc: 'Planos flexíveis que crescem com você.',
      localCommunity: 'Comunidade Local',
      localCommunityDesc: 'Focados em Orlando e região Disney.',
    },
    en: {
      faqTitle: 'Frequently Asked Questions',
      aboutTitle: 'About MagicStay Homes',
      contactTitle: 'Contact Us',
      contactSubtitle: 'Have questions? We are here to help!',
      sendYourMessage: 'Send Your Message',
      yourName: 'Your full name',
      subject: 'Subject',
      subjectPlaceholder: 'What do you want to talk about?',
      messagePlaceholder: 'Write your message here...',
      sendMessage: 'Send Message',
      messageSent: 'Message sent successfully! We will respond soon.',
      messageError: 'Error sending message. Please try again.',
      termsTitle: 'Terms of Service',
      privacyTitle: 'Privacy Policy',
      lastUpdate: 'Last update: December 2024',
      howItWorksTitle: 'How It Works',
      howItWorksSubtitle: 'MagicStay Homes connects property owners and guests simply and transparently',
      forGuests: 'For Guests',
      forHosts: 'For Hosts',
      ourDifference: 'Our Difference',
      traditionalPlatforms: 'Traditional Platforms',
      readyToStart: 'Ready to Start?',
      readySubtitle: 'Join hundreds of hosts who are already saving on commissions',
      startNow: 'Start Now',
      viewFaq: 'View FAQ',
      notFoundAnswer: "Didn't find your answer?",
      teamReady: 'Our team is ready to help!',
      ourNumbers: 'Our Numbers',
      properties: 'Properties',
      guestsConnected: 'Guests Connected',
      averageRating: 'Average Rating',
      transparency: 'Total Transparency',
      transparencyDesc: 'No hidden fees. No booking commissions. Just a clear monthly fee.',
      directContactTitle: 'Direct Contact',
      directContactDesc: 'Guests and hosts communicate directly, without intermediaries.',
      fairGrowth: 'Fair Growth',
      fairGrowthDesc: 'Flexible plans that grow with you.',
      localCommunity: 'Local Community',
      localCommunityDesc: 'Focused on Orlando and Disney region.',
    }
  },

  // ==================== MY ACCOUNT ====================
  account: {
    pt: {
      welcome: 'Bem-vindo,',
      manageAccount: 'Gerencie sua conta e preferências',
      actions: 'Ações',
      savedSearches: 'Buscas Salvas',
      alerts: 'Alertas',
      profile: 'Perfil',
      searchPropertiesTitle: 'Buscar Imóveis',
      searchPropertiesDesc: 'Encontre o imóvel perfeito para suas férias em Orlando',
      startSearch: 'Começar Busca',
      listPropertyTitle: 'Anunciar Meu Imóvel',
      listDescHost: 'Gerencie seus anúncios e visualize suas reservas',
      listDescGuest: 'Liste seu imóvel e comece a receber hóspedes',
      goToDashboard: 'Ir para Painel',
      savedSearchesDesc: 'Gerencie suas buscas salvas e execute-as rapidamente',
      viewAllSaved: 'Ver Todas as Buscas Salvas',
      alertsTitle: 'Alertas de Imóveis',
      alertsDesc: 'Configure alertas para receber notificações quando novos imóveis corresponderem às suas buscas',
      profileInfo: 'Informações do Perfil',
      yourInfo: 'Suas informações pessoais',
      accountType: 'Tipo de Conta',
      hostType: 'Anfitrião',
      guestType: 'Hóspede',
      changePassword: 'Alterar Senha',
      changePasswordDesc: 'Altere sua senha de acesso',
      currentPassword: 'Senha Atual',
      currentPasswordPlaceholder: 'Digite sua senha atual',
      newPasswordPlaceholder: 'Digite sua nova senha (mínimo 6 caracteres)',
      confirmPasswordPlaceholder: 'Confirme sua nova senha',
      changing: 'Alterando...',
      changePasswordBtn: 'Alterar Senha',
      passwordMinLength: 'A nova senha deve ter pelo menos 6 caracteres',
      passwordChanged: 'Senha alterada com sucesso!',
      errorChangingPassword: 'Erro ao alterar senha. Tente novamente.',
    },
    en: {
      welcome: 'Welcome,',
      manageAccount: 'Manage your account and preferences',
      actions: 'Actions',
      savedSearches: 'Saved Searches',
      alerts: 'Alerts',
      profile: 'Profile',
      searchPropertiesTitle: 'Search Properties',
      searchPropertiesDesc: 'Find the perfect property for your vacation in Orlando',
      startSearch: 'Start Search',
      listPropertyTitle: 'List My Property',
      listDescHost: 'Manage your listings and view your reservations',
      listDescGuest: 'List your property and start receiving guests',
      goToDashboard: 'Go to Dashboard',
      savedSearchesDesc: 'Manage your saved searches and run them quickly',
      viewAllSaved: 'View All Saved Searches',
      alertsTitle: 'Property Alerts',
      alertsDesc: 'Set up alerts to receive notifications when new properties match your searches',
      profileInfo: 'Profile Information',
      yourInfo: 'Your personal information',
      accountType: 'Account Type',
      hostType: 'Host',
      guestType: 'Guest',
      changePassword: 'Change Password',
      changePasswordDesc: 'Change your access password',
      currentPassword: 'Current Password',
      currentPasswordPlaceholder: 'Enter your current password',
      newPasswordPlaceholder: 'Enter your new password (minimum 6 characters)',
      confirmPasswordPlaceholder: 'Confirm your new password',
      changing: 'Changing...',
      changePasswordBtn: 'Change Password',
      passwordMinLength: 'New password must be at least 6 characters',
      passwordChanged: 'Password changed successfully!',
      errorChangingPassword: 'Error changing password. Please try again.',
    }
  },

  // ==================== LANGUAGE SELECTION ====================
  languageSelection: {
    pt: {
      title: 'Escolha seu idioma',
      subtitle: 'Selecione o idioma de sua preferência',
      portuguese: 'Português',
      english: 'English',
      continue: 'Continuar',
    },
    en: {
      title: 'Choose your language',
      subtitle: 'Select your preferred language',
      portuguese: 'Português',
      english: 'English',
      continue: 'Continue',
    }
  },

  // ==================== PROPERTY CARD ====================
  propertyCard: {
    pt: {
      compare: 'Comparar',
      sponsored: 'Patrocinado',
      superHost: 'Super Anfitrião',
      verified: 'Verificado',
      perNight: '/noite',
      viewDetails: 'Ver detalhes',
      addedToFavorites: 'Adicionado aos favoritos',
      removedFromFavorites: 'Removido dos favoritos',
      loginToFavorite: 'Faça login para adicionar aos favoritos',
      linkCopied: 'Link copiado!',
      addedToCompare: 'Adicionado à comparação',
      removedFromCompare: 'Removido da comparação',
      maxCompare: 'Você pode comparar no máximo 4 imóveis',
    },
    en: {
      compare: 'Compare',
      sponsored: 'Sponsored',
      superHost: 'Super Host',
      verified: 'Verified',
      perNight: '/night',
      viewDetails: 'View details',
      addedToFavorites: 'Added to favorites',
      removedFromFavorites: 'Removed from favorites',
      loginToFavorite: 'Login to add to favorites',
      linkCopied: 'Link copied!',
      addedToCompare: 'Added to comparison',
      removedFromCompare: 'Removed from comparison',
      maxCompare: 'You can compare up to 4 properties',
    }
  },

  // ==================== FAVORITES ====================
  favorites: {
    pt: {
      title: 'Meus Favoritos',
      favoriteProperty: 'imóvel favorito',
      favoriteProperties: 'imóveis favoritos',
      backToSearch: 'Voltar para Busca',
      noFavoritesYet: 'Nenhum favorito ainda',
      addFavoritesHint: 'Adicione imóveis aos favoritos clicando no ícone de coração',
      exploreProperties: 'Explorar Imóveis',
      removedFromFavorites: 'Removido dos favoritos',
      errorRemoving: 'Erro ao remover favorito',
      loginToView: 'Faça login para ver seus favoritos',
    },
    en: {
      title: 'My Favorites',
      favoriteProperty: 'favorite property',
      favoriteProperties: 'favorite properties',
      backToSearch: 'Back to Search',
      noFavoritesYet: 'No favorites yet',
      addFavoritesHint: 'Add properties to favorites by clicking the heart icon',
      exploreProperties: 'Explore Properties',
      removedFromFavorites: 'Removed from favorites',
      errorRemoving: 'Error removing favorite',
      loginToView: 'Login to view your favorites',
    }
  },

  // ==================== SAVED SEARCHES ====================
  savedSearches: {
    pt: {
      title: 'Buscas Salvas',
      subtitle: 'Gerencie suas buscas salvas e receba alertas de novos imóveis',
      noSearches: 'Você ainda não tem buscas salvas. Faça uma busca e clique em "Salvar Busca".',
      executeSearch: 'Executar Busca',
      manageAlerts: 'Gerenciar Alertas',
      withDrawnArea: 'Com área desenhada',
      createdOn: 'Criado em',
      bedrooms: 'quartos',
      noFilters: 'Sem filtros',
      searchDeleted: 'Busca excluída com sucesso',
      errorDeleting: 'Erro ao excluir busca',
      errorExecuting: 'Erro ao executar busca',
      errorLoading: 'Erro ao carregar buscas salvas',
    },
    en: {
      title: 'Saved Searches',
      subtitle: 'Manage your saved searches and receive alerts for new properties',
      noSearches: 'You don\'t have any saved searches yet. Perform a search and click "Save Search".',
      executeSearch: 'Execute Search',
      manageAlerts: 'Manage Alerts',
      withDrawnArea: 'With drawn area',
      createdOn: 'Created on',
      bedrooms: 'bedrooms',
      noFilters: 'No filters',
      searchDeleted: 'Search deleted successfully',
      errorDeleting: 'Error deleting search',
      errorExecuting: 'Error executing search',
      errorLoading: 'Error loading saved searches',
    }
  },
};

// Helper function to get translation
export const getTranslation = (section, key, language = 'pt') => {
  const lang = language === 'en' ? 'en' : 'pt';
  if (translations[section] && translations[section][lang] && translations[section][lang][key]) {
    return translations[section][lang][key];
  }
  // Fallback to Portuguese if English not found
  if (translations[section] && translations[section].pt && translations[section].pt[key]) {
    return translations[section].pt[key];
  }
  return key; // Return key if translation not found
};

// Get all translations for a section
export const getSectionTranslations = (section, language = 'pt') => {
  const lang = language === 'en' ? 'en' : 'pt';
  if (translations[section] && translations[section][lang]) {
    return translations[section][lang];
  }
  return translations[section]?.pt || {};
};

export default translations;
